import { apiClient } from './client'

export interface Capability {
  key: string
  label: string
  description: string
}

export interface RoleDef {
  id?: string
  key: string
  label: string
  capabilities: string[]
  color?: string | null
  builtin?: boolean
}

export interface CapabilityCatalog {
  capabilities: Capability[]
  builtin_roles: RoleDef[]
}

export interface MyCapabilities {
  role: string
  label: string
  capabilities: string[]
}

export async function getCapabilityCatalog(): Promise<CapabilityCatalog> {
  return (await apiClient.get<CapabilityCatalog>('/roles/capabilities')).data
}

export async function getMyCapabilities(): Promise<MyCapabilities> {
  return (await apiClient.get<MyCapabilities>('/roles/my-capabilities')).data
}

export async function listRoles(): Promise<RoleDef[]> {
  return (await apiClient.get<RoleDef[]>('/roles')).data
}

export async function createRole(data: { label: string; capabilities: string[]; color?: string }): Promise<RoleDef> {
  return (await apiClient.post<RoleDef>('/roles', data)).data
}

export async function updateRole(id: string, data: { label?: string; capabilities?: string[]; color?: string }): Promise<RoleDef> {
  return (await apiClient.put<RoleDef>(`/roles/${id}`, data)).data
}

export async function deleteRole(id: string): Promise<void> {
  await apiClient.delete(`/roles/${id}`)
}
